import * as yup from 'yup'

import { persianTranslationRequired } from '../../../helpers/persianNameValidation'

export const channelFormValidationSchema = yup.object().shape({
  basicDetails: yup.object().shape({
    name: yup.string().required('This field is required'),
    name2: yup.string().required('This field is required'),
    code: yup
      .string()
      .required('This field is required')
      .max(16, 'Use 16 characters or less for Channel Code'),
    IATA: yup.string().required('This field is required'),
    channelType: yup.string().required('This field is required'),
    currency: yup.string().required('This field is required'),
    shortName: yup.string().required('This field is required'),
    // The channel's Persian short name. asset requires ShortNameFA on both
    // validateCreateChannel and validateModifyChannel, and this form had no rule for it at all —
    // so an unfilled one reached the server and came back as a field name matching no label
    // here, exactly as the accommodation one did.
    shortNameTranslatedList: persianTranslationRequired(),
    showProviderName: yup.boolean().required('This field is required')
  })
})
